import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid } from "@financeable-com-au/financeable-ui";
// @ts-expect-error: ignoring as it is existing js file
import { userSelector } from "@/store/slices/userSlice";
import { UserSlice, UserState } from "@/store/slices/types/userSlice";
import { REPORTING_PATHS, userType as USER_TYPE } from "@/constants";
import CommissionReport from "./commissionReport";
import ApplicationsDataReport from "./applicationsDataReport";
import ReportingSidebar from "../../layouts/ReportingSideBar";
import { useFeatureFlags } from "../../utils/featureFlags/useFeatureFlags";
// @ts-expect-error: ignoring as it is existing js file
import BillingWrapper from "../../containers/BillingWrapper";

const REPORTS = {
  [REPORTING_PATHS.APPLICATIONS_DATA]: {
    title: "Applications Data Reports",
    Component: ApplicationsDataReport,
  },
  [REPORTING_PATHS.COMMISSION]: {
    title: "Commission Reports",
    Component: CommissionReport,
  },
} as const;

const Reporting = () => {
  const navigate = useNavigate();
  const { path } = useParams();
  const { isCommissionEnabled } = useFeatureFlags();
  const { isAdmin, permissions, userType } = useSelector<UserSlice, UserState>(userSelector);
  const canViewCommissionReport = isCommissionEnabled() && Boolean(permissions?.commission?.report_view);
  const canViewApplicationsDataReport =
    Boolean(isAdmin) ||
    [USER_TYPE.admin, USER_TYPE.owner].includes(userType) ||
    [USER_TYPE.admin, USER_TYPE.owner].includes(permissions?.userType);
  const selectedReport = path ? REPORTS[path as keyof typeof REPORTS] : undefined;
  const SelectedReportComponent = selectedReport?.Component;
  const canViewSelectedReport =
    (path === REPORTING_PATHS.COMMISSION && canViewCommissionReport) ||
    (path === REPORTING_PATHS.APPLICATIONS_DATA && canViewApplicationsDataReport);

  useEffect(() => {
    if (!selectedReport || !canViewSelectedReport) {
      navigate("/404");
    }
  }, [canViewSelectedReport, navigate, selectedReport]);

  return (
    <>
      <Grid container gap={3} height="100%" width="100%" direction="row">
        <Grid
          container
          xs={12}
          sm={3}
          md={2}
          lg={2}
          width="100%"
          justifyContent="start"
          alignItems="start"
          direction="column"
        >
          <ReportingSidebar
            path={path as string}
            canViewCommissionReport={canViewCommissionReport}
            canViewApplicationsDataReport={canViewApplicationsDataReport}
          />
        </Grid>
        {selectedReport && SelectedReportComponent && canViewSelectedReport && (
          <Grid
            container
            xs={12}
            sm={9}
            md={9}
            lg={8}
            width="100%"
            justifyContent="start"
            alignItems="start"
            direction="column"
          >
            {/* We are using same wrapper as billing for now. */}
            <BillingWrapper title={selectedReport.title}>
              <SelectedReportComponent />
            </BillingWrapper>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Reporting;
